<template>
  <div class="card" style="width: 18rem">
    <div class="card-body">
      <h5 class="card-title">El archivo ocasionó un error</h5>
      <p class="card-text">Por favor adjunte el archivo que ocasionó el error en la carpeta de Google Drive del Fondecyt.</p>
    </div>
  </div>
</template> 

<script>
export default {
  name: "ErrorHtml",
};
</script>